import { Navigate, Outlet, useLocation } from 'react-router';
import { useAuth } from '@/shared/auth';
import { useMemo } from 'react';

export const LoggedInRedirectGuard = () => {
  const { isAuthenticated, onboardingState } = useAuth();
  const { pathname } = useLocation();

  const redirectUrl = useMemo(() => {
    if (!isAuthenticated) {
      return null;
    }

    if (onboardingState === 'NEEDS_SHOP') {
      return '/signup/shop';
    } else if (onboardingState === 'COMPLETED') {
      // Race-fix preserved from PR #608: CreateShop's onSuccess invalidates
      // /current-user (auth state flips to COMPLETED) then navigates to
      // /starter-estimate. If this guard re-evaluates between those two
      // events, send the user where CreateShop was about to send them.
      // The earlier SHOW_ONBOARDING version of this special case is gone
      // (state was removed in Plan 3); the race itself still exists.
      // Exact-match pathname avoids future-route prefix collisions
      // (e.g., a hypothetical /signup/shop/confirm would otherwise be
      // caught by startsWith).
      if (pathname === '/signup/shop') {
        return '/starter-estimate';
      }
      return '/';
    }
    return null;
  }, [isAuthenticated, onboardingState, pathname]);

  if (redirectUrl && pathname !== redirectUrl) {
    return <Navigate to={redirectUrl} replace />;
  }

  return <Outlet />;
};
